export default __webpack_public_path__ + "static/media/img1.5f1a7f39.jpg";